import React from "react";
import classnames from "classnames";
import {
  toErrorMessage,
  UserBatchValidateResult,
} from "../../../application/domain/user/user-batch-import-result";
import { CsvFileType } from "../csv-uploader";
import { Checkbox } from "@graffer-inc/console-design-kit";

export const BatchImportPreview: React.FC<{
  process: "一括登録" | "一括更新";
  file: CsvFileType | undefined;
  validateResult: UserBatchValidateResult;
  execImport: () => void;
  isBatchImporting: boolean;
  returnButtonEvent: () => void;
  doSendInvitation: boolean;
  orgId: string; // feature-flag用なのでリリース時は取り除く
}> = ({
  process,
  file,
  validateResult,
  execImport,
  isBatchImporting,
  returnButtonEvent,
  doSendInvitation,
}) => {
  const canExecImport = validateResult.isValid;
  const errors = validateResult.results
    .filter((r) => r.errors != null)
    .map((r) => r.errors)
    .reduce((acc, cur) => acc.concat(cur), []);
  const errorCount = errors?.filter((e) => e.severity === "error").length;
  const warnCount = errors?.filter((e) => e.severity === "warn").length;
  const previewMessage =
    errorCount === 0 && warnCount === 0
      ? `取込内容を確認し、${process}を実行する場合は実行ボタンを押下してください。`
      : canExecImport
        ? `${warnCount}件の警告があります。取込内容を確認し、${process}を実行する場合は実行ボタンを押下してください。`
        : `${warnCount}件の警告、${errorCount}件のエラーがあります。CSVファイルを修正して再度アップロードしてください。`;

  return (
    <>
      <section className="modal-card-body">
        <div className="mb-4">
          <p>{previewMessage}</p>
        </div>
        <table className="table is-fullwidth is-bordered">
          <thead>
            <tr>
              <th>アカウント名</th>
              <th>氏名</th>
              <th>エラー/警告</th>
            </tr>
          </thead>
          <tbody>
            {validateResult.results.map((r) => {
              const hasError =
                r.errors && r.errors.some((e) => e.severity === "error");
              return (
                <tr
                  key={r.user.accountName}
                  className={classnames({
                    "has-background-warning-light":
                      r.errors && r.errors.length > 0 && !hasError,
                    "has-background-danger-light": hasError,
                  })}
                >
                  <td>{r.user.accountName}</td>
                  <td>{r.user.name}</td>
                  <td>
                    {r.errors && (
                      <ul className="ml-4" style={{ listStyleType: "disc" }}>
                        {r.errors.map((e, i) => (
                          <li key={`${r.user.accountName}-error-${i}`}>
                            {toErrorMessage(e.errCode, e.additionalErrData)}
                          </li>
                        ))}
                      </ul>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>
      <footer className="modal-card-foot" style={{ display: "initial" }}>
        <div className="columns">
          {process === "一括登録" && (
            <Checkbox
              label=""
              description={""}
              options={[
                {
                  value: "doSendInvitation",
                  name: "仮パスワードをメールで送信する",
                  disabled: true,
                  description: doSendInvitation
                    ? ""
                    : "メールを送信する場合はCSVアップロード時に選択してください。",
                },
              ]}
              values={doSendInvitation ? ["doSendInvitation"] : []}
            />
          )}
        </div>
        <div className="buttons" style={{ flexWrap: "initial" }}>
          <button
            className="button is-failure is-fullwidth"
            onClick={returnButtonEvent}
          >
            戻る
          </button>
          <button
            className={classnames("button is-info is-fullwidth")}
            onClick={execImport}
            disabled={!file || isBatchImporting || !canExecImport}
          >
            {process}を実行する
          </button>
        </div>
      </footer>
    </>
  );
};
